import React from 'react';
import PropTypes from 'prop-types';
import { styles, Typography } from '../../index';
import classNames from 'classnames';

const WellTitle = props => {
  const classes = useStyles();
  return (
    <Typography
      variant={'h4'}
      className={classNames(classes.root, props.className)}
      data-testid={props['data-testid']}>
      {props.children}
    </Typography>
  );
};

WellTitle.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  'data-testid': PropTypes.string,
};

const useStyles = styles.makeStyles(
  (theme) => ({
    root: {
      textAlign: 'center',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 34,
      color: theme.palette.primary.main,
    },
  })
);


export default WellTitle;
